export const country = {
  china: "China",
  korea: "Korea",
  russia: "Russia",
};
